export enum DataTarget {
  DEFAULT_DATA_LAYER = 'dataLayer',
  CHECKOUT_DATA_LAYER = 'checkoutDataLayer',
  NINETAILED = 'ninetailed',
  SEGMENT_SERVER_SIDE = 'segmentServerSide'
}

export type EventData = {
  event: string;
};
